import { client } from './client';

// --- Invoice Templates (nested under service) ---

export const getInvoiceTemplatesByService = async (serviceUid) => {
    const response = await client.get(`/v1/services/${serviceUid}/invoice-templates`);
    return response.data?.items ?? response.data;
};

export const createInvoiceTemplate = async (serviceUid, data) => {
    const response = await client.post(`/v1/services/${serviceUid}/invoice-templates`, data);
    return response.data;
};

export const updateInvoiceTemplate = async (uid, data) => {
    const response = await client.put(`/v1/invoice-templates/${uid}`, data);
    return response.data;
};

export const deleteInvoiceTemplate = async (uid) => {
    const response = await client.delete(`/v1/invoice-templates/${uid}`);
    return response.data;
};
